/********************************************************************
 * Autocomplete by kraaden/autocomplete for ke_search
 *
 * https://github.com/kraaden/autocomplete
 */

import autocomplete from 'autocompleter';

// Search input inside lightbox
let inputLightbox = document.getElementById('ke_search_searchfield_sword');
if (inputLightbox != null) {
  autocomplete({
    input: inputLightbox,
    debounceWaitMs: 500,
    fetch: function(text, update) {
      fetch(text, update, inputLightbox.getAttribute('data-ws-search-data-pid'));
    },
    render: render,
    renderGroup: renderGroup,
    onSelect: function(item) {
      jQuery( "#ke_search_searchfield_sword" ).val( item.value );
      jQuery( "form#form_kesearch_searchfield" ).submit();
    }
  });
}


// Search input on search page
let inputSearchpage = document.getElementById("ke_search_sword");
if (inputSearchpage != null) {
  autocomplete({
    input: inputSearchpage,
    debounceWaitMs: 500,
    fetch: function(text, update) {
      fetch(text, update, inputSearchpage.getAttribute('data-ws-search-data-pid'));
    },
    render: render,
    renderGroup: renderGroup,
    onSelect: function(item) {
      jQuery( "#ke_search_sword" ).val( item.value );
      jQuery( "form#form_kesearch_pi1" ).submit();
    }
  });
}

function render(item, currentValue) {
  if (item.group !== 'suggestions') {
    // Wenn "Search for xxx everywhere" nicht angezeigt werden soll,
    // einfach die folgende Zeile einkommentieren:
    // return null;
  }
  const div = document.createElement("div");
  div.textContent = item.label;
  return div;
}

function renderGroup(groupName, currentValue) {
  if (groupName === 'suggestions') {
    const div = document.createElement("div");
    div.textContent = 'Suchvorschläge:';
    div.style.fontWeight = 'bold';
    return div;
  }
  return null;
}

function fetch(text, update, pid) {
  jQuery.ajax({
    url: "/?eID=keSearchAutocomplete",
    dataType: "json",
    cache: false,
    data: {
      needle: text,
      amount: 10,
      pid: pid
    },
    success: function (hits) {
      if (hits) {
        var direct = [
          {
            label: 'Nach "' + text.trim() + '" suchen',
            value: text,
          }
        ];
        var suggestions = direct.concat(hits);
        update(suggestions);
      }
    }
  });
}
